import api from '@/api';

function hasProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

export default {
  list: (tab, searchQuery) =>
    new Promise((resolve, reject) => {
      const filter = {
        query: {
          bool: {
            must: [],
          },
        },
      };

      if (tab) {
        filter.query.bool.must.push({
          term: {
            status: tab,
          },
        });
      }

      if (searchQuery) {
        filter.query.bool.must.push({
          match: {
            title: {
              query: searchQuery,
              operator: 'and',
              zero_terms_query: 'all',
              fuzziness: 'AUTO',
            },
          },
        });
      }

      // If filter has 'must' options set
      if (filter.query.bool.must[0]) {
        api()
          .put('/content/pages/flat', { filter })
          .then((response) => {
            resolve(response.data.data.page);
          })
          .catch((error) => {
            if (error.response && hasProp(error.response.data.data, 'page')) {
              resolve(error.response.data.data.page);
            } else {
              reject(error.response.data);
            }
          });
      } else {
        api()
          .get('/content/pages/flat')
          .then((response) => {
            resolve(response.data.data.page);
          })
          .catch((error) => {
            if (error.response && hasProp(error.response.data.data, 'page')) {
              resolve(error.response.data.data.page);
            } else {
              reject(error.response.data || error);
            }
          });
      }
    }),

  create: page =>
    new Promise((resolve, reject) => {
      api()
        .put('/content/page', { page })
        .then((response) => {
          resolve(response.data.data.page[0]);
        })
        .catch((error) => {
          if (error.response && hasProp(error.response.data.data, 'page')) {
            resolve(error.response.data.data.page[0]);
          } else {
            reject(error.response.data);
          }
        });
    }),

  read: {
    // Read page by id
    byId: pageId =>
      new Promise((resolve, reject) => {
        const apiEndpoint = `/content/page/${pageId}`;

        api()
          .get(apiEndpoint)
          .then((response) => {
            const page = response.data.data.page[0];
            resolve(page);
          })
          .catch((error) => {
            if (error.response && hasProp(error.response.data.data, 'page')) {
              resolve(error.response.data.data.page[0]);
            } else {
              reject(error.response.data);
            }
          });
      }),

    // Read page by slug
    bySlug: pageSlug =>
      new Promise((resolve, reject) => {
        const apiEndpoint = '/content/pages';
        const filter = {
          query: {
            match: {
              slug: pageSlug,
            },
          },
        };

        api()
          .put(apiEndpoint, { filter })
          .then((response) => {
            const page = response.data.data.page[0];
            resolve(page);
          })
          .catch((error) => {
            if (error.response && hasProp(error.response.data.data, 'page')) {
              resolve(error.response.data.data.page[0]);
            } else {
              reject(error.response.data);
            }
          });
      }),
  },

  update: (pageId, pageData) =>
    new Promise((resolve, reject) => {
      const apiEndpoint = `/content/page/${pageId}`;

      api()
        .put(apiEndpoint, { page: pageData })
        .then((response) => {
          resolve(response.data.data.page[0]);
        })
        .catch((error) => {
          if (error.response && hasProp(error.response.data.data, 'page')) {
            resolve(error.response.data.data.page[0]);
          } else {
            reject(error.response);
          }
        });
    }),

  delete: pageId =>
    new Promise((resolve, reject) => {
      api()
        .delete(`/content/page/${pageId}`)
        .then(() => {
          resolve('deleted');
        })
        .catch((error) => {
          if (error.response && hasProp(error.response.data.data, 'page')) {
            resolve(error.response.data.data.page[0]);
          } else {
            console.log('error', { ...error });
            reject(error);
          }
        });
    }),

  // -------------------------

  approve: pageId =>
    new Promise((resolve, reject) => {
      api()
        .put(`/content/page/${pageId}/approve`)
        .then((response) => {
          resolve(response.data.data.page[0]);
        })
        .catch((error) => {
          if (error.response && hasProp(error.response.data.data, 'page')) {
            resolve(error.response.data.data.page[0]);
          } else {
            reject(error.response.data);
          }
        });
    }),

  reject: params =>
    new Promise((resolve, reject) => {
      api()
        .put(`/content/page/${params.pageId}/reject`, { reject: { reason: params.reason } })
        .then((response) => {
          resolve(response.data.data.page[0]);
        })
        .catch((error) => {
          if (error.response && hasProp(error.response.data.data, 'page')) {
            resolve(error.response.data.data.page[0]);
          } else {
            reject(error.response.data);
          }
        });
    }),
};
